import React from 'react';
import { useFormikContext } from 'formik';
import CustomSidebar from 'shared/CustomSidebar';
import EditRowSidebarFields from 'pages/InsideSales/InsideSalesList/InsideSalesListTable/InsideSalesListTableModals/InsideSalesEditRowSidebarForm/EditRowSidebarFields';
import { editRequestTitle, viewRequestTitle } from 'pages/InsideSales/InsideSalesList/constants';

interface IEditRowSidebarProps {
  isViewMode: boolean
  isLoadingItem: boolean
  allowedFields: string[]
  cleanEditRow: () => void
  showStatusField: boolean
  editRowId: string | number | undefined | null
}

const EditRowSidebar: React.FC<IEditRowSidebarProps> = ({
  editRowId, isLoadingItem, isViewMode, showStatusField, allowedFields, cleanEditRow,
}) => {
  const {
    dirty, isSubmitting, submitForm, setErrors, resetForm,
  } = useFormikContext();

  const withLeaveConfirmation = !isViewMode && dirty && !isSubmitting;
  const sidebarTitle = isViewMode ? viewRequestTitle : editRequestTitle;

  const closeEditRowSidebar = () => {
    cleanEditRow();
    setErrors({});
    resetForm();
  };

  return (
    <CustomSidebar
      isOpen={!!editRowId}
      onCloseSideBar={closeEditRowSidebar}
      title={sidebarTitle}
      onClickSave={submitForm}
      areButtonsVisible={!isViewMode as boolean}
      isConfirmDialog={withLeaveConfirmation}
    >
      <EditRowSidebarFields
        editRowId={editRowId}
        isViewMode={isViewMode}
        allowedFields={allowedFields}
        isLoadingItem={isLoadingItem}
        showStatusField={showStatusField}
        isDisabled={isViewMode as boolean}
      />
    </CustomSidebar>
  );
};

export default EditRowSidebar;
